import { useAuth0 } from "@auth0/auth0-react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from '@material-ui/core';
import Dialog from "@material-ui/core/Dialog";
import TableRow from '@material-ui/core/TableRow';
import Pagination from '@material-ui/lab/Pagination';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import PrintIcon from "@mui/icons-material/Print";
import Paper from '@mui/material/Paper';
import sortImg from 'assets/icons/sort-able-svg.svg';
import { CheckBox } from "components/CheckBox/CheckBox";
import ClearGroupFilter from "components/clearGroupFilter";
import AlertDialog from "components/Dialog/index";
import RightDrawer from 'components/drawer';
import FinanceDrawer from "pages/NewFinance/Drawer";
import ChargeLoader from "pages/Forms/membersDetails/ParticipantDetailsTable/ChargeLoader";
import { useFetchData } from "hook/useFetchData";
import FinanceService from "Lib/API/Finance/index";
import MyButton from "components/MyButton";
import SendLetter from "components/SendLetter/SendLetter";
import SuccessModal from "components/SuccessModal/SuccessModal";
import { formatDate, numberFormat } from "helper";
import PreSchoolService from "Lib/API/PreSchool";
import React, { useEffect, useRef, useState } from 'react';
import { toastr } from "react-redux-toastr";
import { useReactToPrint } from "react-to-print";
import { getFormDataHandler } from "utils/formDataHelper";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import ParticipantDetailsTableBody from './ParticipantDetailsTableBody';
import ParticipantDrawer from './ParticipantDrawer/ParticipantDrawer';
import { ButtonContainer, TableTitle } from './Theme';


const ParticipantDetailsTable = ({ getClassParticipants, filter, setFilter, participantsPage, setParticipantsPage, count, rows, loading, classId, onSharePaymentLinkClick, participantGroupId }) => {
  const { getAccessTokenSilently } = useAuth0();

  const componentRef = useRef();


  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [check, setCheck] = useState([]);
  const [checkAll, setCheckAll] = useState(false)
  const [openLetterModal, setOpenLetterModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [sendLetterLoading, setSendLetterLoading] = useState(false);
  const [exportData, setExportData] = React.useState([]);
  const [exportType, setExportType] = useState("");
  const [confirmClose, setConfirmClose] = useState(false);
  const [chargeModal, setChargeModal] = useState(false);
  const { data: chargeData, loading: chargeLoading, fetchData } = useFetchData(FinanceService.getAllTransactionsEnhance);

  const closeModalCharge = () => setChargeModal(false);
  const openModalCharge = (transactionId) => {
    fetchData(1, 30, { search: transactionId, filter: { hidden: true } });
    setChargeModal(true);
  };


  console.log('exportData :', exportData);
  const styleButtons = { color: '#454758', fontSize: '14px', fontWeight: '400' }


  const HeaderTitles = [
    {
      label: 'ACCOUNT',
      value: 'account',
    },
    {
      label: 'FIRST NAME',
      value: 'firstName',
    },
    {
      label: 'LAST NAME',
      value: 'lastName',
    },
    {
      label: 'DATE OF BIRTH',
      value: 'dateOfBirth',
    },
    {
      label: 'SCHOOL GRADE',
      value: 'schoolGrade',
    },
    {
      label: 'REGISTRATION STATUS',
      value: 'registrationStatus',
    },
    {
      label: 'STATUS',
      value: 'paymentStatus',
    },
    {
      label: 'PAYMENT AMOUNT',
      value: 'paymentAmount',
    },
  ];
  const columns_for_header = [
    {
      id: "firstName",
      displayName: "First Name",
      headerName: "First Name",
      field: "firstName",
      flex: 1,
    },
    {
      id: "lastName",
      displayName: "Last Name",
      headerName: "Last Name",
      field: "lastName",
      flex: 1,
    },
    {
      id: "dateOfBirth",
      displayName: "Date Of Birth",
      headerName: "Date Of Birth",
      field: "dateOfBirth",
      flex: 1,
    },
    {
      id: "schoolGrade",
      displayName: "School Grade",
      headerName: "School Grade",
      field: "schoolGrade",
      flex: 1,
    },
    {
      id: "registrationStatus",
      displayName: "Registration Status",
      headerName: "Registration Status",
      field: "registrationStatus",
      flex: 1,
    },
    {
      id: "paymentStatus",
      displayName: "Status",
      headerName: "Status",
      field: "paymentStatus",
      flex: 1,
    },
    {
      id: "paymentAmount",
      displayName: "Payment Amount",
      headerName: "Payment Amount",
      field: "paymentAmount",
      flex: 1,
    },
  ];


  const getExportFileName = () => {
    return check?.[0]?.class?.class_name ? `${check?.[0]?.class?.class_name}.xlsx` : `Participants.xlsx`
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: getExportFileName(),
  });

  const handleSortChange = (name) => {
    setFilter((prev) => ({
      ...prev,
      sort: {
        [name]: prev.sort[name] === 1 ? -1 : 1,
      }
    }));
  };


  useEffect(() => {
    if (participantGroupId) {
      getClassParticipants(1);
      setParticipantsPage(1);
    } else {
      getClassParticipants();
    }
  }, [refresh, filter, participantGroupId]);


  const onCheckboxAllChange = (e) => {
    const items = rows
    setCheckAll(e.target.checked)
    if (!e.target.checked) {
      return setCheck([]);
    }
    const allChecked = [...check, ...items].filter(
      (item, index, self) => index === self.findIndex((i) => i._id === item._id)
    );
    setCheck(allChecked);
  };

  const onCheckboxChange = (e, row) => {
    setCheckAll(false)
    const { checked } = e.target;
    if (!checked) {
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item._id !== row._id);
        return [...checkClone];
      });
      return;
    }
    setCheck((prev) => [
      ...prev,
      row

    ]);
  };

  const handleSendLetter = async (templateData) => {
    setSendLetterLoading(true);
    const token = await getAccessTokenSilently();
    const bodyData = {
      participantsIds: checkAll ? undefined : check.map((item) => item._id),
      classIds: checkAll ? [classId] : undefined,
      ...templateData
    }

    PreSchoolService.sendClassParticipantLetter(token, bodyData)
      .then((response) => {
        setOpenSuccessModal(true);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      }).finally(() => {
        setSendLetterLoading(false);
        setOpenLetterModal(false);
      });
  };

  const totalPaymentCalculation = (approveTotalPaid, registerTotalPaid) => {
    const totalPayment = +approveTotalPaid + +registerTotalPaid
    return numberFormat({ number: totalPayment || 0, decimal: 2, style: 'currency' })
  }

  const excelSheet = () => {
    const arr = [];
    if (exportData?.length > 0) {
      exportData.map((item) => {
        const data = {
          ["First Name"]: item?.firstName,
          ["Last Name"]: item?.lastName,
          ["Date Of Birth"]: formatDate({ date: item?.dateOfBirth, formatType: "defaultWithUTC" }),
          ["School Grade"]: item?.class?.class_details?.grade,
          ["Registration Status"]: item?.registrationStatus,
          ["Status"]: item?.payment?.approve?.status,
          ["Payment Amount"]: totalPaymentCalculation(item?.payment?.approve?.totalPaid, item?.payment?.register?.totalPaid),
          ...getFormDataHandler(item?.class?.form?.task_data, item?.formData),
          ...getFormDataHandler(item?.parentInfoForm?.task_data, item?.parentInfo, "Parent"),
          ...(item?.products?.reduce((acc, product) => {
            if (product?.quantity) acc[product.title] = product.quantity;
            if (product?.variant) Object.entries(product.variant).forEach(([k, v]) => { acc[`${product.title}-${k}`] = v; });
            return acc;
          }, {}) || {})
        };
        arr.push(data);
      });
    }
    return arr;
  };
  const generateExcel = () => {
    let res = excelSheet()
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(res));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      getExportFileName()
    );
  };
  const downloadExcel = () => {
    getExportData("excel");
  };

  const getExportData = async (value) => {
    const token = await getAccessTokenSilently();
    const ides = checkAll ? [] : check.map(item => {
      return item._id
    });
    const body = { classId: classId, participantsIds: ides }
    PreSchoolService.exportClassParticipant(token, body)
      .then((res) => {
        setExportData(res?.data);
        checkAll && setCheck(res?.data)
        setExportType(value);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      });
  };

  useEffect(() => {
    if (exportType == "print") {
      handlePrint();
    } else if (exportType == "excel") {
      generateExcel();
    }
    setExportType("");
  }, [exportType]);


  let customExportData = []
  let myData =
    exportData?.length !== 0
    && exportData?.map((item) => {
      const data = {
        firstName: item?.firstName,
        lastName: item?.lastName,
        dateOfBirth: item?.dateOfBirth ? formatDate({ date: item?.dateOfBirth, formatType: "default" }) : '',
        schoolGrade: item?.class?.class_details?.grade,
        registrationStatus: item?.registrationStatus,
        paymentStatus: item?.payment?.approve?.status,
        paymentAmount: totalPaymentCalculation(item?.payment?.approve?.totalPaid, item?.payment?.register?.totalPaid),
      };
      customExportData.push(data);
    })


  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenDrawer(false);
  }



  return (
    <div className="w-100">
      <div className={'family-table-container pl-7 pr-6 pt-3 pb-22'}>
        <>
          <div className="d-flex justify-content-between mb-5">
            <div className="d-flex align-items-center" style={{
              gap: "15px",
              marginTop: "15px",
              marginBottom: "13px"
            }}>
              <TableTitle>
                Capacity {count}
              </TableTitle>
              {participantGroupId && (
                <ClearGroupFilter text="Filtered By Group" />
              )}
            </div>
            {check?.length > 0 && (
              <div className="new-class mt-4">
                <MyButton
                  type="secondary"
                  content={
                    <ButtonContainer>
                      <FileDownloadIcon style={{ height: "20px" }} />
                      <a
                        style={styleButtons}
                      >
                        Export
                      </a>
                    </ButtonContainer>
                  }
                  style={{
                    background: "#F4F6F9",
                    color: "#2555EF",
                    border: "none",
                    marginRight: "1rem",
                  }}
                  onClick={downloadExcel}
                />
                <MyButton
                  type="secondary"
                  onClick={() => getExportData("print")}
                  content={
                    <ButtonContainer>
                      <PrintIcon style={{ height: "20px" }} />
                      <a
                        style={styleButtons}
                      >
                        Print
                      </a>
                    </ButtonContainer>
                  }
                  style={{
                    background: "#F4F6F9",
                    color: "#2555EF",
                    border: "none",
                    marginRight: "1rem",
                  }}
                />
                <span className="button-line" />
                <MyButton
                  onClick={() => setOpenLetterModal(true)}
                  type="secondary"
                  content={
                    <ButtonContainer>
                      <ForwardToInboxIcon style={{ height: "20px" }} />
                      Send Letter: {checkAll ? count : check.length}
                    </ButtonContainer>
                  }
                  style={{
                    background: "#D3DDFC",
                    color: "#2555EF",
                    border: "none",
                    marginRight: "1rem",
                    padding: "0px 25px",
                  }}
                />
              </div>
            )}
          </div>
        </>
        <div className="home-table-container mt-0 no-box-shadow">
          <TableContainer component={Paper} className="scroll-table">
            <Table class="main-table" aria-label="collapsible table">
              <TableHead className="charges-table sticky-table-header">
                <TableRow>
                  <TableCell className="charged-value-check-box" align="left">
                    <CheckBox
                      onChange={(e) => {
                        onCheckboxAllChange(e);
                      }}
                      text={""}
                      style={{ paddingTop: 8, paddingLeft: 5 }}
                      checked={checkAll}
                    />
                  </TableCell>
                  {HeaderTitles.map((Item) => (
                    <TableCell className="charged-value" align="left">
                      {Item?.label}
                      {Item?.value !== 'account' && Item?.value !== 'paymentStatus' && Item?.value !== 'paymentAmount' && <IconButton
                        onClick={
                          Item?.value !== 'schoolGrade'
                            ? () => handleSortChange(Item?.value)
                            : undefined
                        }
                      >
                        <img src={sortImg} alt="sort" />
                      </IconButton>}
                    </TableCell>
                  ))}
                  <TableCell className="empty-head sticky-header-column" align="left" />
                  <TableCell className="empty-head" align="left" />
                </TableRow>
              </TableHead>
              <TableBody className="tran-table-body">
                <ParticipantDetailsTableBody
                  rows={rows}
                  setOpenDrawer={setOpenDrawer}
                  setDrawerData={setDrawerData}
                  loading={loading}
                  classId={classId}
                  refresh={refresh}
                  setRefresh={setRefresh}
                  onSharePaymentLinkClick={onSharePaymentLinkClick}
                  onCheckboxChange={onCheckboxChange}
                  check={check}
                  checkAll={checkAll}
                />
              </TableBody>
            </Table>
          </TableContainer>
          <div className="pagination-custom mt-20">
            {/* <Pagination count={10} variant="outlined" /> */}
            <Pagination
              count={Math.ceil(count / 30)}
              color="primary"
              variant="outlined"
              page={participantsPage}
              onChange={(event, value) => {
                setParticipantsPage(value);
                getClassParticipants(value);
              }}
            />
          </div>
          <div className="d-none">
            <div id="componentRef" ref={componentRef}>
              <table style={{ padding: 10, margin: 10 }}>
                <thead>
                  {columns_for_header?.map((column, index) => (
                    <th
                      style={{ border: "1px solid", textAlign: "center" }}
                      key={index}
                    >
                      {column?.headerName}
                    </th>
                  ))}
                </thead>
                <tbody>
                  {customExportData?.map((item, index) => {
                    const d = {
                      ["First Name"]: item?.firstName,
                      ["Last Name"]: item?.lastName,
                      ["Date Of Birth"]: item?.dateOfBirth ? formatDate({ date: item?.dateOfBirth, formatType: "default" }) : '',
                      ["School Grade"]: item?.schoolGrade,
                      ["Registration Status"]: item?.registrationStatus,
                      ["Status"]: item?.paymentStatus,
                      ["Payment Amount"]: item?.paymentAmount,
                    };
                    return (
                      <tr key={index}>
                        {Object?.values(d)?.map((objectValue, index) => (
                          <td
                            style={{
                              border: "1px solid",
                              padding: 5,
                            }}
                            key={index}
                          >
                            {objectValue}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <RightDrawer
          open={openDrawer}
          onClose={closeModal}
        >
          <ParticipantDrawer
            drawerData={drawerData}
            closeModal={closeModal}
            handleClose={() => setOpenDrawer(false)}
            onSharePaymentLinkClick={onSharePaymentLinkClick}
            getClassParticipants={getClassParticipants}
            openModalCharge={openModalCharge}
            closeModalCharge={closeModalCharge}
          />
        </RightDrawer>
        <RightDrawer open={!!chargeModal} onClose={closeModalCharge}>
          <div className="finance-drawer">
            {chargeLoading ? (
              <ChargeLoader />
            ) : (
              <FinanceDrawer
                data={chargeData?.payload?.data?.[0] ?? {}}
                onReversalClick={() => {}}
                hideActions
                onPaymentSuccess={() => {
                  getClassParticipants();
                }}
              />
            )}
          </div>
        </RightDrawer>
        <Dialog
          open={openLetterModal}
          onClose={() => {
            setOpenLetterModal(false);
            setCheck([]);
          }}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <SendLetter
            closeModal={() => {
              setOpenLetterModal(false);
            }}
            initialEmails={(check?.length === 1) ? check[0]?.account?.defaultEmails || [] : []}
            isMultiple={check?.length > 1}
            handleSendLetter={handleSendLetter}
            sendLetterLoading={sendLetterLoading}
            type="education"
          />
        </Dialog>
        <Dialog
          open={openSuccessModal}
          onClose={() => {
            setOpenSuccessModal(false);
          }}
          PaperProps={{
            style: {
              width: "800px",
              height: "400px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
        >
          <SuccessModal
            title="Successfully Sent"
            description={`The total number of recipients is ${check.length}`}
            btnText="Done"
            btnAction={() => {
              setOpenSuccessModal(false);
            }}
            closeModal={() => {
              setOpenSuccessModal(false);
            }}
          />
        </Dialog>
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
    </div>
  );
};

export default ParticipantDetailsTable;
